import React, { useRef, useState, useEffect } from "react";
import nineDotIcon from "../../images/nineDotIcon.svg";
import gileadCsIcon from "../../images/gileadCSIcon.svg";
import bellIconDot from "../../images/bellIconDot.svg";
import bellIcon from "../../images/belliconWithoutDot.svg";
import filterIcon from "../../images/FilterIcon.svg";
import UnreadEmpty from "../../images/UnreadEmpty.svg";
import expiredIcon from "../../images/expired status.svg";
import UpexpandIcon from "../../images/UpexpandIcon.png";
import DownexpandIcon from "../../images/DownexpandIcon.png";
import "../../styles/pages/BannerTemplateManager.scss";
import "../../styles/LogoutCard.scss";
import LogoutDropdownCard from "../../components/Manager/LogoutDropdownCard";
import { useKeycloak } from "@react-keycloak/web";
import { Dropdown } from "react-bootstrap";
import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";
import Drawer from "@mui/material/Drawer";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import Switch from "@mui/material/Switch";
import Divider from "@mui/material/Divider";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip from "@mui/material/Tooltip";
import Popover from "@mui/material/Popover";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import {
  getExpiryNotifications,
  readAndUnreadNotifications,
} from "../../services/apis";
import config from "../../config/index";

const CustomMenu = React.forwardRef(
  (
    { style, className, "aria-labelledby": labeledBy, children, ...props },
    ref,
  ) => {
    const handleClick = (e) => {
      e.stopPropagation();
      if (props.onClick) {
        props.onClick(e);
      }
    };

    return (
      <div
        ref={ref}
        style={style}
        className={`logoutDropdownWrapper dropdown-menu ${className || ""}`}
        aria-labelledby={labeledBy}
        onClick={handleClick}
      >
        <ul className="list-unstyled appDropdown mb-0">{children}</ul>
      </div>
    );
  },
);

const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: 400,
    height: "100%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    borderTopLeftRadius: 12,
    borderBottomLeftRadius: 12,
    zIndex: theme.zIndex?.drawer,
  },

  paperAnchorRight: {
    borderTopLeftRadius: 12,
    borderBottomLeftRadius: 12,
  },
  drawerBody: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  topBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px 8px 16px",
  },
  headerLeft: { display: "flex", alignItems: "center" },
  bellCircle: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    background: "#EEF3F8",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 10,
  },
  bellImg: { width: 16, height: 16, display: "block" },
  bellImgWithoutdot: { width: 24, height: 24, display: "block" },

  headerTitle: {
    fontWeight: 800,
    letterSpacing: 0.25,
    color: "#232425",
    fontSize: 13.5,
  },
  closeBtn: {
    width: 28,
    height: 28,
    padding: 0,
    color: "#203662",
    "& .MuiSvgIcon-root": {
      fontSize: 18,
      stroke: "currentColor",
      strokeWidth: 1,
    },
  },

  controlsRow: {
    display: "flex",
    alignItems: "center",
    padding: "0 16px 12px 16px",
  },
  leftGroup: {
    display: "flex",
    alignItems: "center",
    "& > *:not(:last-child)": { marginRight: 8 },
  },
  unreadLabel: { fontSize: 12, fontWeight: 600, color: "#231f20" },
  switch: { transform: "translateY(1px)" },

  filtersPill: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    marginLeft: "auto",
    marginRight: 12,
    border: "1px solid #E5E7EB",
    borderRadius: 999,
    padding: "6px 12px",
    lineHeight: 1,
    cursor: "pointer",
    userSelect: "none",
    background: "#fff",
  },
  filtersBadge: {
    position: "absolute",
    top: -6,
    right: -3,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 15,
    height: 15,
    padding: "0 0",
    fontSize: 8,
    fontWeight: 700,
    lineHeight: 1,
    borderRadius: 999,
    background: "#203662",
    color: "#fff",
    pointerEvents: "none",
  },
  filtersIcon: { width: 12, height: 12, marginRight: 6 },
  filtersText: { fontSize: 13, fontWeight: 600, color: "#203662" },

  resetLink: {
    border: "none",
    background: "transparent",
    fontSize: 12,
    fontWeight: 700,
    color: "#203662",
    cursor: "pointer",
    padding: 0,
    lineHeight: 1,
  },
  resetLinkDisabled: {
    border: "none",
    background: "transparent",
    fontSize: 12,
    fontWeight: 700,
    color: "#203662",
    opacity: 0.45,
    cursor: "default",
    padding: 0,
    lineHeight: 1,
    pointerEvents: "none",
  },
  subHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 16px",
  },
  subHeaderLeft: { fontSize: 12, fontWeight: "bold", color: "#231f20" },
  subHeaderRight: {
    fontSize: 12,
    fontWeight: "bold",
    color: "rgb(32, 54, 98)",
    cursor: "pointer",
  },
  markallDisable: {
    fontSize: 12,
    fontWeight: "bold",
    color: "rgb(169, 170, 172)",
    cursor: "not-allowed",
  },

  scrollArea: {
    flex: "1 1 auto",
    overflowY: "auto",
    padding: "8px 16px 16px 16px",
  },
  card: {
    border: "1px solid #E3E8EF",
    borderRadius: 10,
    padding: 12,
    marginBottom: 12,
    background: "#fff",
    transition: "box-shadow .15s ease",
    "&:hover": { boxShadow: "0 1px 6px rgba(0,0,0,.06)" },
  },
  unreadCard: {
    border: "1px solid #E3E8EF",
    borderRadius: 10,
    padding: 12,
    marginBottom: 12,
    background: "#f2f6f9",
    transition: "box-shadow .15s ease",
    cursor: "pointer",
    "&:hover": { boxShadow: "0 1px 6px rgba(0,0,0,.06)" },
  },
  cardTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 6,
  },
  cardTitle: { fontSize: "12px", fontWeight: "bold", color: "rgb(30, 30, 30)" },
  cardTime: {
    marginLeft: "auto",
    fontSize: 12,
    color: "rgb(169, 170, 172)",
    fontWeight: "normal",
  },
  metaRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 8,
    fontSize: 13,
  },
  idLabel: { fontWeight: 500, color: "#111827" },
  idLink: { color: "rgb(32, 54, 98)", fontWeight: 700, textDecoration: "none" },
  chip: {
    fontSize: 8,
    fontWeight: 600,
    color: "rgb(255, 255, 255);",
    background: "rgb(169, 170, 172)",
    border: "1px solid #E5E7EB",
    borderRadius: 4,
    padding: "2px 6px",
  },
  bellCircleHeader: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    background: "#EEF3F8",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
  headerBellBtn: { padding: 0 },
  headerBellBadge: {
    "& .MuiBadge-badge": {
      right: -2,
      top: 2,
    },
  },
  notiTip: {
    background: "#fff",
    color: "#1f2937",
    boxShadow: "0 8px 24px rgba(0,0,0,.12)",
    borderRadius: 12,
    padding: "10px 12px",
    maxWidth: 280,
    fontSize: 12,
    lineHeight: 1.4,
    border: "1px solid #E5E7EB",
  },
  notiTipArrow: {
    color: "#fff",
    "&:before": {
      boxShadow: "0 2px 8px rgba(0,0,0,.12)",
      border: "1px solid #E5E7EB",
    },
  },
  filtersPillActive: {
    "&&": {
      border: "1px solid #203662",
      background: "#fff",
    },
  },
  filterMenuPaper: {
    borderRadius: 12,
    boxShadow: "0 8px 24px rgba(0,0,0,.12)",
    minWidth: 220,
  },
  filterList: { padding: 0 },
  filterItem: {
    padding: "10px 16px",
    "&:hover": {
      backgroundColor: "#F3F6FB !important",
    },
    "& .MuiListItemText-primary": {
      color: "inherit",
      fontSize: 14,
      fontWeight: 600,
    },
  },

  filterItemSelected: {
    padding: "10px 16px",
    backgroundColor: "#EFF6FF !important",
    "&:hover": {
      backgroundColor: "#DBEAFE !important",
    },
    "& .MuiListItemText-primary": {
      color: "inherit",
      fontSize: 14,
      fontWeight: 600,
    },
  },

  filterText: { fontSize: 14 },
}));

const IOSwitch = withStyles((theme) => ({
  root: { width: 34, height: 20, padding: 0, marginLeft: 6 },
  switchBase: {
    padding: 2,
    "&$checked": { transform: "translateX(14px)", color: "#fff" },
    "&$checked + $track": {
      backgroundColor: "#1E66E6",
      opacity: 1,
      border: "none",
    },
  },
  thumb: { width: 16, height: 16, boxShadow: "none" },
  track: {
    borderRadius: 20,
    backgroundColor: "#878888",
    opacity: 1,
  },
  checked: {},
}))(Switch);

const Header = () => {
  const classes = useStyles();
  const { keycloak } = useKeycloak();
  const getNotificationStatusLabel = (status) => {
    if (typeof status === "string") {
      const normalizedStatus = status.trim();
      if (normalizedStatus) {
        return normalizedStatus;
      }
    }
    return "Expired";
  };

  const getFirstLetters = () => {
    const userName = !!keycloak.authenticated
      ? keycloak.tokenParsed.name
      : null;
    if (!userName) return "";
    return userName
      .split(" ")
      .map((n) => n.charAt(0))
      .join("");
  };
  const getUserNameEmail = () => (!!keycloak.authenticated ? keycloak : null);
  const goToUnifiedLoginPage = () => {
    window.location.href = config.unifiedPageUrl;
  };
  const [notifOpen, setNotifOpen] = useState(false);
  const [notificationsState, setNotificationsState] = useState([]);
  const hasUnread = notificationsState.some((n) => n.isRead);
  const [unreadOnly, setUnreadOnly] = useState(false);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const isFilterOpen = Boolean(filterAnchorEl);
  const [filterValue, setFilterValue] = useState("All");
  const filterCount = filterValue === "All" ? 0 : 1;
  const FILTER_OPTIONS = [
    "All",
    "Modules",
    "Banners",
    "Claims",
    "Reusable Texts",
    "Components",
  ];

  const handleOpenFilters = (e) => setFilterAnchorEl(e.currentTarget);
  const handleCloseFilters = () => setFilterAnchorEl(null);
  const handleSelectFilter = (val) => {
    setFilterValue(val);
    handleCloseFilters();
  };

  const handleReset = () => {
    setFilterValue("All");
    setUnreadOnly(false);
    handleCloseFilters();
    if (scrollRef.current)
      scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
  };

  const filteredNotifications = notificationsState.filter((n) => {
    // const filternewVal = filterValue === "Banners" ? "Banner Ads" : filterValue;
    // const passesType = filterValue === "All" || n.type === filternewVal;
    const passesType = n.type === "Banner Ads";

    const passesUnread = unreadOnly ? !n.isRead : true;
    return passesType && passesUnread;
  });

  const normalizedFilter =
    filterValue === "Banners" ? "Banner Ads" : filterValue;

  const unreadCount = notificationsState.filter(
    (n) =>
      !n.isRead && ( n.type === "Banner Ads"),
  ).length;

  let currentViewLabel = "";

  if (unreadOnly) {
    currentViewLabel = filterValue === "All" ? "All" : `${filterValue}`;
  } else {
    currentViewLabel = filterValue;
  }

  const isResetDisabled = filterValue === "All" && !unreadOnly;
  const [markallasRead, setMarkallasRead] = useState(() => {
    return localStorage.getItem("markallasRead") === "true";
  });
  useEffect(() => {
    localStorage.setItem("markallasRead", markallasRead);
  }, [markallasRead]);
  useEffect(() => {
    const allRead = notificationsState.every((n) => n.isRead);
    if (!allRead) {
      setMarkallasRead(false);
      localStorage.setItem("markallasRead", false);
    }
  }, [notificationsState]);
  const scrollRef = useRef(null);

  useEffect(() => {
    getNotifications();
  }, []);
  const getNotifications = () => {
    getExpiryNotifications(async (response, err) => {
      if (err) {
        console.error(err);
      } else {
        try {
          const data = await response.data;
          const userEmail = window.localStorage.getItem("userEmail");
          const formatted = data.map((n) => {
            const userNotification = n.notificationUsers?.find(
              (u) => u.user_id === userEmail,
            );
            return {
              ...n,
              status: getNotificationStatusLabel(n?.status),
              isRead: userNotification?.read ?? false,
            };
          });

          setNotificationsState(formatted);
          const allRead =
            formatted.length > 0 && formatted.every((n) => n.isRead);

          setMarkallasRead(allRead);
          localStorage.setItem("markallasRead", allRead);
        } catch (e) {
          console.error("Error processing notifications:", e);
        }
      }
    });
  };

  const readAndMarkallNotifications = (id, isMarkAll) => {
    const markAllAsReadNotificationInfo = {
      userNotification: {
        userId: window.localStorage.getItem("userEmail"),
        read: true,
      },
      updateType: "markAllAsRead",
      filterType: normalizedFilter,
    };

    const singleNotificationInfo = {
      userNotification: {
        userId: window.localStorage.getItem("userEmail"),
        read: true,
      },
      notificationId: id,
      updateType: "readSingleNotification",
    };

    const notificationInfo = isMarkAll
      ? markAllAsReadNotificationInfo
      : singleNotificationInfo;

    readAndUnreadNotifications(notificationInfo, async (response, err) => {
      if (err) {
        console.error("API error:", err);
      } else {
        try {
          setNotificationsState((prev) =>
            isMarkAll
              ? prev.map((item) => {
                  if (
                    !item.isRead &&
                    (filterValue === "All" || item.type === normalizedFilter)
                  ) {
                    return { ...item, isRead: true };
                  }
                  return item;
                })
              : prev.map((item) =>
                  item.id === id ? { ...item, isRead: true } : item,
                ),
          );
          if (!isMarkAll) {
            const notification = notificationsState.find(
              (item) => item.id === id,
            );
            if (!notification) return;

            const { title, documentId } = notification;
            if (!documentId) return;

            let url = "";

            switch (title?.toLowerCase()) {
              case "claim expired":
                url = `${config.globalPromomatsUrl}#t/0TB00000000Y011/V1X/${documentId}?_layout_new__c&expanded=details__c&s=0`;
                break;
              case "module expired":
                url = `${config.globalPromomatsUrl}#doc_info/${documentId}`;
                break;
              case "reusable text expired":
                url = `${config.globalPromomatsUrl}#t/0TB00000000Y012/${documentId}`;
                break;
              case "banner ad expired":
                url = `${config.globalPromomatsUrl}#doc_info/${documentId}`;
                break;
              case "component expired":
                url = `${config.globalPromomatsUrl}#doc_info/${documentId}`;
                break;
              default:
                return;
            }

            window.open(url);
          }
        } catch (e) {
          console.error("Error processing notifications:", e);
        }
      }
    });
  };
  const formatDateToEDT = (isoDateString) => {
    if (!isoDateString) return "";

    const date = new Date(isoDateString);
    const timeZone = "America/New_York";

    const day = date.toLocaleString("en-US", { timeZone, day: "numeric" });
    const month = date.toLocaleString("en-US", { timeZone, month: "numeric" });
    const year = date.toLocaleString("en-US", { timeZone, year: "numeric" });

    const time = date
      .toLocaleString("en-US", {
        timeZone,
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })
      .replace(" ", "");

    const tz = date
      .toLocaleString("en-US", { timeZone, timeZoneName: "short" })
      .split(" ")
      .pop();

    return `${day}/${month}/${year}, ${time} ${tz}`;
  };

  const CustomUserToggle = React.forwardRef(({ onClick }, ref) => {
    const initials = getFirstLetters();
    const chevronIcon = userMenuOpen ? UpexpandIcon : DownexpandIcon;

    return (
      <button
        ref={ref}
        type="button"
        className="userPill"
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
        aria-haspopup="true"
        aria-expanded={userMenuOpen}
      >
        <div className="userPill-avatar">
          <span className="userPill-initials">{initials}</span>
        </div>

        <span className="userPill-chevron">
          <img
            src={chevronIcon}
            alt={userMenuOpen ? "Collapse user menu" : "Expand user menu"}
            className="userPill-chevronIcon"
          />
        </span>
      </button>
    );
  });

  return (
    <div className="header">
      <div className="left-side">
        <img
          src={nineDotIcon}
          style={{ cursor: "pointer" }}
          onClick={goToUnifiedLoginPage}
        />
        <img src={gileadCsIcon} style={{ marginLeft: 16 }} />
      </div>
      <div className="right-side">
        <div>
          <div className="source-text">Source</div>
          <strong>PromoMats</strong>
        </div>

        <div className="noti-icon-class1">
          <Tooltip
            arrow
            placement="bottom"
            enterDelay={300}
            classes={{ tooltip: classes.notiTip, arrow: classes.notiTipArrow }}
            title={
              <span>
                Click to view notifications for
                <br />
                expired Elements, Modules,
                <br />
                and Materials in the
                <br />
                last 30 days.
              </span>
            }
          >
            <IconButton
              className={classes.headerBellBtn}
              aria-label="Open notifications"
              onClick={() => {
                setNotifOpen(true);
                getNotifications();
              }}
              size="large"
            >
              <Badge
                variant="dot"
                color="secondary"
                overlap="circular"
                invisible={!hasUnread}
                className={classes.headerBellBadge}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <span className={classes.bellCircleHeader}>
                  <img
                    src={unreadCount > 0 ? bellIconDot : bellIcon}
                    alt="notifications"
                    className={
                      unreadCount > 0
                        ? classes.bellImg
                        : classes.bellImgWithoutdot
                    }
                  />
                </span>
              </Badge>
            </IconButton>
          </Tooltip>
        </div>

        <div>
          <Dropdown
            className="logOutButton"
            align="end"
            show={userMenuOpen}
            onToggle={(isOpen) => setUserMenuOpen(isOpen)}
          >
            <Dropdown.Toggle as={CustomUserToggle} id="logoutButton" />

            <Dropdown.Menu as={CustomMenu}>
              <LogoutDropdownCard
                getFirstLetters={getFirstLetters}
                getUserNameEmail={getUserNameEmail()}
              />
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <Drawer
        anchor="right"
        open={notifOpen}
        onClose={() => setNotifOpen(false)}
        classes={{
          paper: classes.drawerPaper,
          paperAnchorRight: classes.paperAnchorRight,
        }}
        ModalProps={{ keepMounted: true }}
      >
        <div className={classes.drawerBody}>
          <div className={classes.topBar}>
            <div className={classes.headerLeft}>
              <span className={classes.bellCircle}>
                <img src={bellIconDot} alt="" className={classes.bellImg} />
              </span>
              <Typography className={classes.headerTitle}>
                NOTIFICATION
              </Typography>
            </div>
            <IconButton
              className={classes.closeBtn}
              onClick={() => {
                setNotifOpen(false);
                handleReset();
              }}
              aria-label="Close"
              size="large"
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className={classes.controlsRow}>
            <div className={classes.leftGroup}>
              <Typography className={classes.unreadLabel}>
                Unread Notifications(
                {/* {unreadOnly ? filteredNotifications.length : unreadCount} */}
                {unreadCount}
                )
              </Typography>
              <IOSwitch
                checked={unreadOnly}
                onChange={(e, v) => setUnreadOnly(v)}
                className={classes.switch}
              />
            </div>

            {/* <div
              className={`${classes.filtersPill} ${
                filterCount ? classes.filtersPillActive : ""
              }`}
              onClick={handleOpenFilters}
            >
              <img src={filterIcon} alt="" className={classes.filtersIcon} />
              <span className={classes.filtersText}>Filters</span>
              {filterCount > 0 && (
                <span className={classes.filtersBadge}>1</span>
              )}
            </div>

            <Popover
              open={isFilterOpen}
              anchorEl={filterAnchorEl}
              onClose={handleCloseFilters}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              transformOrigin={{ vertical: "top", horizontal: "center" }}
              PaperProps={{ className: classes.filterMenuPaper }}
            >
              <List className={classes.filterList} disablePadding>
                {FILTER_OPTIONS.map((opt) => (
                  <ListItem
                    key={opt}
                    button
                    onClick={() => handleSelectFilter(opt)}
                    selected={filterValue === opt}
                    className={
                      filterValue === opt
                        ? classes.filterItemSelected
                        : classes.filterItem
                    }
                  >
                    <ListItemText
                      primary={opt}
                      primaryTypographyProps={{ className: classes.filterText }}
                    />
                  </ListItem>
                ))}
              </List>
            </Popover>

            <button
              type="button"
              className={
                isResetDisabled ? classes.resetLinkDisabled : classes.resetLink
              }
              onClick={isResetDisabled ? undefined : handleReset}
            >
              Reset
            </button> */}
          </div>

          <Divider />
          <div className={classes.subHeader}>
            <span className={classes.subHeaderLeft}>
              {currentViewLabel} ({filteredNotifications.length})
            </span>
            <span
              className={
                markallasRead || unreadCount === 0
                  ? classes.markallDisable
                  : classes.subHeaderRight
              }
              onClick={() => {
                if (!markallasRead && unreadCount > 0) {
                  setMarkallasRead(true);
                  readAndMarkallNotifications("", true, "");
                }
              }}
            >
              Mark all as Read
            </span>
          </div>
          <div className={classes.scrollArea} ref={scrollRef}>
            {filteredNotifications.map((n) => (
              <div
                key={n.id}
                className={n.isRead ? classes.card : classes.unreadCard}
                onClick={() =>
                  readAndMarkallNotifications(n.id, false, n.title)
                }
              >
                <div className={classes.cardTitleRow}>
                  <Typography className={classes.cardTitle}>
                    {n.title}
                  </Typography>
                  <span className={classes.cardTime}>
                    {formatDateToEDT(n.expiredAt)}
                  </span>
                </div>

                <div className={classes.metaRow}>
                  <span className={classes.idLabel}>ID :</span>
                  <img src={expiredIcon} className="img-fluid" />
                  <a
                    className={classes.idLink}
                    href="#"
                    onClick={(e) => e.preventDefault()}
                  >
                    {n.documentNumber}
                  </a>
                  <span className={classes.chip}>
                    {getNotificationStatusLabel(n?.status)}
                  </span>
                </div>
              </div>
            ))}
            {((unreadCount === 0 && unreadOnly) ||
              filteredNotifications.length === 0) && (
              <div className="unreadImgdiv">
                <img src={UnreadEmpty} className="img-fluid unreadImg" />
                <div className="unreadEmpty">
                  You’ve reviewed all your notifications <br />
                  from the past 30 days.Try searching <br />
                  with different filter settings.
                </div>
              </div>
            )}
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default Header;
